import {
  DOWNLOAD_INVOICES_FAILURE,
  DOWNLOAD_INVOICES_REQUEST,
  DOWNLOAD_INVOICES_RESET,
  DOWNLOAD_INVOICES_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const downloadInvoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_INVOICES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case DOWNLOAD_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case DOWNLOAD_INVOICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case DOWNLOAD_INVOICES_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default downloadInvoicesReducer
